module.exports = __webpack_public_path__ + "fd41da0f161d725c5a7ed2a76ac2b9f6.svg";